import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f1e73aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "info-overlay-container",
  id: "weather-forecast-container"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Forecast", -1))
const _hoisted_3 = {
  key: 0,
  class: "time-location"
}
const _hoisted_4 = { class: "omf-hl" }
const _hoisted_5 = { class: "omf-hl" }
const _hoisted_6 = {
  key: 1,
  class: "time-location"
}
const _hoisted_7 = {
  key: 2,
  class: "forecast-table-div"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "No data for this hour", -1))
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "forecast-table" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Cloud cover:", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Temperature:", -1))
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Precipitation Probability:", -1))
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Precipitation:", -1))
const _hoisted_18 = { class: "acknowledgement" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://open-meteo.com",
  target: "_blank"
}, "Open-Meteo", -1))
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.ncei.noaa.gov/products/weather-climate-models/global-forecast",
  target: "_blank"
}, "Global", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://rapidrefresh.noaa.gov/hrrr/",
  target: "_blank"
}, "HRRR", -1))
const _hoisted_23 = { key: 1 }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.ecmwf.int/en/forecasts/datasets/open-data",
  target: "_blank"
}, "ECMWF", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://open-meteo.com/en/docs/ecmwf-api",
  target: "_blank"
}, "3hr", -1))
const _hoisted_26 = { class: "mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.time !== null)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
          _createTextVNode(" for April 8 at "),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.localTimeString), 1),
          _createTextVNode(", the hour of max eclipse at "),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.locationStr), 1)
        ]))
      : (_openBlock(), _createElementBlock("p", _hoisted_6, " Not provided for locations where the eclipse is not visible")),
    (_ctx.time !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_ctx.forecastForHour === null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_v_icon, { size: "35" }, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-cloud-cancel")
                  ]),
                  _: 1
                }),
                _hoisted_9
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("table", _hoisted_11, [
                  _createElementVNode("tr", null, [
                    _hoisted_12,
                    _createElementVNode("td", null, _toDisplayString(_ctx.forecastForHour.cloud_cover) + "%", 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_13,
                    _createElementVNode("td", null, _toDisplayString(_ctx.cfPref === 'C' ? _ctx.forecastForHour.temperature_2m : _ctx.celsiusToFahrenheit(_ctx.forecastForHour.temperature_2m)) + "°" + _toDisplayString(_ctx.cfPref), 1)
                  ]),
                  (_ctx.forecastForHour.precipitation_probability !== undefined)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                        _hoisted_15,
                        _createElementVNode("td", null, _toDisplayString(_ctx.forecastForHour.precipitation_probability) + "%", 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.forecastForHour.precipitation !== undefined)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                        _hoisted_17,
                        _createElementVNode("td", null, _toDisplayString(_ctx.forecastForHour.precipitation) + " mm", 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])),
          _createVNode(_component_v_btn_toggle, {
            class: "mt-3 align-center",
            modelValue: _ctx.cfPref,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.cfPref) = $event)),
            color: "#eac402",
            density: "compact",
            divided: "",
            mandatory: "",
            "hide-details": "",
            variant: "outlined"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                value: "C",
                size: "small",
                height: "2em"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("°C")
                ]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                value: "F",
                size: "small",
                height: "2em"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("°F")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("p", null, [
        _createTextVNode(" Forecast powered by "),
        _hoisted_19,
        _createTextVNode(" using "),
        (_ctx.openMeteoApi==='gfs')
          ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
              _createTextVNode("NOAA GFS ("),
              _hoisted_21,
              _createTextVNode(" & "),
              _hoisted_22,
              _createTextVNode(") forecast models. ")
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_23, [
              _createTextVNode("the "),
              _hoisted_24,
              _createTextVNode(),
              _hoisted_25,
              _createTextVNode(" forecast model. ")
            ]))
      ]),
      _createElementVNode("p", _hoisted_26, [
        _createTextVNode(" Use the "),
        _createElementVNode("a", {
          href: "",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.openMeteoApi = _ctx.openMeteoApi === 'gfs' ? 'ecmwf' : 'gfs'), ["prevent"]))
        }, _toDisplayString(_ctx.openMeteoApi === 'gfs' ? 'ECMWF' : 'NOAA GFS'), 1),
        _createTextVNode(" forecast model instead. ")
      ])
    ])
  ]))
}